module.exports = __webpack_public_path__ + "assets/img/qzone.0bec55c7.svg";